import Button from 'common-ui/button';
import styled from 'styled-components';

export const FilterContainer = styled.div`
  background: #ffffff;
  border: 0.4px solid #dfdfdf;
  border-radius: 8px;
  padding: 22px 26px;
  margin-top: 20px;
`;

export const MainActionsRow = styled.div`
  .actions-left {
    display: flex;
    gap: 12px;
    align-items: center;
    label {
      display: none;
    }
    .action-button {
      max-height: 38px;
      max-width: 110px;
      font-size: 12px;
      color: #212529;
      font-style: normal;
      line-height: normal;
      img {
        color: white;
      }
    }
  }
`;

export const IconButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 14px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  border: 0.5px solid #d4d8dd;
  background: #ffffff12;
  color: #212529;
  height: 38px;
  transition: all 0.2s ease;
  width: fit-content;

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
  &.is-active {
    border: 0.5px solid #2d6cdf;
    background: #eff6ff;
    color: #2d6cdf;

    img {
      filter: invert(38%) sepia(84%) saturate(1108%) hue-rotate(195deg) brightness(93%)
        contrast(89%);
    }
  }
`;

export const ActionIcon = styled.img`
  width: 14px;
  height: 14px;
`;

export const FilterRow = styled.div`
  > div {
    > div > div {
      min-height: auto;
      > div > div {
        min-height: 38px;
      }
    }
  }
`;
export const FilterRowLine = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  flex-wrap: wrap;
  > div {
    min-width: 138px;
  }
  date-group {
    flex: 2;
  }

  .date-inputs {
    display: flex;
    gap: 10px;
    > div {
      width: 148px;
      flex: 1;
    }
  }
  @media (max-width: 768px) {
    gap: 15px 10px;

    > div {
      min-width: calc(50% - 10px);
    }

    .date-group {
      width: 100%;
      flex: 1 1 100%;
    }
    .ePtCWa .MuiOutlinedInput-root {
      height: 38px;
    }
  }

  @media (max-width: 480px) {
    > div {
      width: 100%;
    }

    .date-inputs {
      flex-direction: column;
      > div {
        width: 100%;
      }
    }
  }
`;

export const FilterLabel = styled.label`
  color: #212529;
  font-weight: 600;
  margin: 4px 0;
  display: block;
  font-size: 12px;
`;

export const InputWrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  > div {
    min-height: 38px;
    label {
      color: #6c757d;
      font-weight: 700;
      font-size: 12px;
    }
  }
  &.change-status {
    width: fit-content;
  }
  .css-17hzp7b-control,
  .css-mkw8ed-control {
    background: #2d6cdf;
    border: none;
    box-shadow: none;
    cursor: pointer;
    border-radius: 10px;
    min-height: 38px;
    min-width: 158px;
    text-align: center;

    &:hover {
      border: none;
      box-shadow: none;
    }
  }
  .css-evdxjr-placeholder {
    color: white !important;
    font-weight: 700 !important;
    font-size: 12px;
    line-height: 100%;
    letter-spacing: 0%;
  }
  .css-1xc3v61-indicatorContainer,
  .css-15lsz6c-indicatorContainer {
    padding-left: 0;
    display: none;
    img {
      filter: brightness(0) invert(1);
      width: 12px;
      height: auto;
    }
  }

  [class*='-indicatorSeparator'] {
    display: none;
  }
  .search-inputs {
    width: 304px;
  }
  @media (max-width: 707px) {
    &.change-status {
      > div {
        flex: 0;
      }
    }
    > div {
      flex: 1 1 100%;
      max-width: none;
    }

    .search-inputs {
      max-width: none;
      width: 100%;
    }
  }
  @media (max-width: 430px) {
    &.change-status {
      width: 100%;
      > div {
        width: 100%;
        flex: 1;
      }
    }
  }
`;

export const Line = styled.div`
  border-top: 1px solid #e2e8f0;
  padding: 16px 0 0;
  width: 100%;
  margin-top: 23px;
  position: relative;
`;

export const ClearAllRow = styled.div`
  position: absolute;
  right: 0;
  bottom: 15px;
  &.close-x {
    bottom: auto;
    top: 10px;
    .close-x-icon {
      width: 20px;
      height: 20px;
    }
    @media (max-width: 865px) {
      top: -2px;
      right: -15px;
    }
  }
  @media (max-width: 1525px) {
    bottom: -18px;
  }
`;

export const ClearAllText = styled.span`
  cursor: pointer;
  color: #212529;
  font-size: 10px;
  font-weight: 700;
  text-decoration: underline;
  &:hover {
    color: #0284c7;
  }
`;

export const CloseIconWrapper = styled.div`
  cursor: pointer;
  padding: 4px;
`;

export const Icon = styled.img`
  width: 14px;
  height: 14px;
`;
